import { auth, firestore } from "../firebase";
/* import { GoogleAuthProvider } from "firebase/auth";
import { FacebookAuthProvider } from "firebase/auth"; */

const state = {
  usuario: null,
  verified: null,
};
const mutations = {
  setUser(state, user) {
    state.usuario = user;
  },
  isVerified(state, verificado) {
    state.verified = verificado;
  },
};

const actions = {
  limpiarStore({ commit }) {
    commit("setUser", null);
  },
  /* regtistro de usuario */
  async doRegister(
    { commit, state },
    {
      nombre,
      apellidos,
      email,
      nombreUsuario,
      password,
      areaDesempeño,
      especializacion,
      terminosYCondiciones,
      enviarInfoPorEmail,
      cupon,
    }
  ) {
    await auth.createUserWithEmailAndPassword(email, password);
    const user = auth.currentUser;
    await user.updateProfile({
      displayName: nombre,
    });
    commit("setUser", user);
    await firestore.collection("usuarios").doc(state.usuario.uid).set({
      id_usuario: state.usuario.uid,
      nombre: nombre,
      apellidos: apellidos,
      email: email,
      nombreUsuario:nombreUsuario,
      areaDesempeño: areaDesempeño,
      especializacion: especializacion,
      fechaRegistro: new Date(),
      isFree: true,
      condicionesYpoliticas: terminosYCondiciones,
      enviarEmails: enviarInfoPorEmail,
      cupon:cupon,
    });
  },

  /* inicio de sesion con email y contraseña */
  async doLogin({ commit }, { email, password }) {
    await auth.signInWithEmailAndPassword(email, password);
    commit("setUser", auth.currentUser);
  },

  getCurrentUser({ commit }) {
    //creamos la promesa
    return new Promise((resolve, reject) => {
      //creamos la constante unsubscribe, este tendra el metodo onAuthStateChanged
      //esto devuelve una promesa, recibimos user y devolvemos unsuscribe(se retorna a si mismo)
      //si todo salve bien resolvemos con user
      const unsubscribe = auth.onAuthStateChanged(
        (user) => {
          unsubscribe();
          resolve(user);
          if (user != null) {
            let isUserVerified = user.emailVerified;
            commit("isVerified", isUserVerified);
          }
        },
        () => {
          //si algo falla, lanzamos reject
          reject();
        }
      );
    });
  },

  //salimos del usuario, usamos el metodo signOut, solo es asi

  async doLogout({ commit }) {
    await auth.signOut();
    commit("setUser", null);
  },
  //accion para recupera contraseña pasamos un email para nueva contraseña
  async doReset(context, email) {
    await auth.sendPasswordResetEmail(email);
  },

  async limpiarStore({ commit }) {
    commit("setUser", null);
    commit("isVerified", null);
  },

  async verificarEmail() {
    let user = auth.currentUser;

    user
      .sendEmailVerification()
      .then(function () {
        let msg = "Te hemos enviado un correo,revisa tu  bandeja de entrada";
        return msg;
      })
      .catch(function (e) {
         msg = "Ha sucedido un error, vuelve a intentarlo";
        return msg;
      });
  },
};
const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
